import isNull from 'lodash/isNull';

export function updateAttributes<P extends object>(it: P, params: Partial<P>, strict = false): void {
    const itKeys = new Set(Object.keys(it));
    Object.keys(params).forEach(key => {
        if (!strict || itKeys.has(key)) {
            // @ts-expect-error
            it[key] = isNull(params[key as keyof Partial<P>])
                ? null
                : (params[key as keyof Partial<P>] ?? it[key as keyof P]);
        }
    });
}
